import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

type WrapperProps = {
  leftspace: number
}

export const Wrapper = styled(Box)<WrapperProps>(({ theme, leftspace }) => ({
  padding: theme.spacing(3, 6),
  marginLeft: leftspace,
  backgroundColor: '#FCFCFC',
  height: '100vh',
  transition: theme.transitions.create('margin')
}));
